<template>
  <mymodal
    ref="theModal"
    :need-header="true"
    :need-footer="false"
    :size="'medium'"
  >
    <div slot="title">{{ getTitleText }}</div>
    <div slot="body">
      <div v-if="item">
        <form class="land-form" v-on:submit.prevent="submitForm">
       
          <selectlocation
            v-if="item"
            :province="item.province_id"
            :district="item.district_id"
            :commune="item.commune_id"
            :is_get_location="false"
            @updateLocation="updateLocation"
          ></selectlocation>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Sản lượng dự kiến(tấn) <span class="required">(*)</span></label>
                <input
                  required
                  type="number"
                  step="any" 
                  :placeholder="'Quantity' | translate"
                  v-model="item.estimate_quantity"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ "Price" | translate }} (ngàn vnd/kg) <span class="required">(*)</span></label>
                <input
                  required
                  type="number"
                  :placeholder="'Price' | translate"
                  min="0"
                  v-model="item.unit_price"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="row">
       
       <div class="col-md-12">
         <div class="form-group">
           <label>Ngày tuổi trái(từ khi xả nhụy đến hôm nay) <span class="required">(*)</span></label>
           <input
             required
             type="number"
             :placeholder="'Price' | translate"
             min="0"
             v-model="item.growing_days"
             class="form-control"
           />
         </div>
       </div>

       <div class="col-md-12">

       
       <div class="form-group" v-if="item.id && item.approved == '1'">
            <label>Trạng thái</label>
            <select
              class="form-control"
              v-model="item.status"
            >
              
              <option
                v-for="item in all_status"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
     </div>



          <div class="row mt20">
            <div class="col-md-12">
              <p>
                <strong>{{ "Attached images" | translate }}</strong>
              </p>
              <div class="insert-gallery">
                <input
                  type="file"
                  id="file-upload"
                  ref="file"
                  multiple
                  v-on:change="handleFileUpload()"
                  style="display: none"
                />
                <a
                  class="btn btn-primary btn-sm"
                  :disabled="uploadingPhoto"
                  v-on:click="triggerFile"
                >
                  <i v-if="!uploadingPhoto" class="fa fa-plus"></i>
                  <i v-if="uploadingPhoto" class="fas fa-spinner fa-spin"></i>
                  {{ "Select files to upload" | translate }}
                </a>
              </div>
              <div class="gallery">
                <p v-if="item.photos.length == 0">
                  {{ "There is no photo" | translate }}
                </p>
                <div v-else>
                  <div v-for="photo, index in item.photos" :key="photo.id"
                    class="gallery-item"
                  >
                    <img :src="photo.thumb_path" class="thumb" />
                    <a v-on:click="removePhoto(index)" class="btn btn-danger">
                      <i class="fas fa-times"></i>
                      {{ "Remove" | translate }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="mt20">{{ "Description" | translate }}</label>
                <wysiwyg required v-model="item.description" />
              </div>
            </div>
          </div>

          <p>
            <button
              class="btn btn-success mt20"
              type="submit"
              :disabled="working"
            >
              <span v-if="item.id">{{ "Update" | translate }}</span>
              <span v-if="!item.id">{{ "Publish" | translate }}</span>
            </button>
          </p>
        </form>
      </div>
    </div>
  </mymodal>
</template>

<script>
import mymodal from '@/components/elements/Modal'
import Utils from '@/helpers/utils'
import CoffeeAdHelper from '@/helpers/CoffeeAdHelper'
import Loading from '@/components/elements/Loading'
import selectlocation from '@/components/elements/SelectLocation'
import datePicker from 'vue-bootstrap-datetimepicker'

// import GoogleAutocomplete from 'google-autocomplete-vue';
// https://farmbook.com/API/listProvinces
export default {
  title: 'FormSubUser',
  components: {
    mymodal,
    Loading,
    selectlocation,
    datePicker
  },
  props: ['pass_data'],
  computed: {
    priceFormat () {
      if (!this.item.price || this.item.price > this.max_price) {
        return ''
      } else {
        return new Intl.NumberFormat('en-US').format(this.item.price) + ' VND'
      }
    },
    getTitleText () {
      if (this.item && this.item.id) {
        return this.$t('Update news')
      } else {
        return this.$t('Add news')
      }
    },
    getOKText () {
      if (this.item.id) {
        return this.$t('Update')
      } else {
        return this.$t('Publish')
      }
    }
  },
  data () {
    let dateFormat = 'DD/MM/YYYY'
    return {
      uploadingPhoto: false,
      working: false,

      dateFormat: dateFormat,
      all_status: [
        { id: '1', name: 'Đang bán' },
        { id: '2', name: 'Đã bán' },
      ],
      item: null,
      config: {
        format: dateFormat,
        locale: 'vi',
        maxDate: new Date()
      },
    }
  },
  created () {
    // clone from original params
  },
  mounted () {
    console.log('on mounted')
    CoffeeAdHelper.listVariants(this).then(result => {
      this.variants = result
    })
  },
  methods: {
    defaultValue () {
      return {
        province_id: '',
        district_id: '',
        commune_id: '',
        growing_days: 0,
        estimate_quantity:0,
        description: '',
        photos: []
      }
    },

    triggerFile () {
      this.$refs.file.click()
    },
    handleFileUpload () {
      if (this.$refs.file.files.length + this.item.photos.length > 5) {
        return this.$alertify.alertWithTitle(
          this.$t('Confirm'),
          'Tối đa được upload 5 ảnh'
        )
      }
      for (var i = 0; i < this.$refs.file.files.length; i++) {
        this.uploadSingleFile(this.$refs.file.files[i])
      }
    },

    uploadSingleFile (file) {
      if (file.size > 3000000) {
        return alert('Ảnh phải có dung lượng nhỏ hơn 3MB')
      }
      var validExtensions = ['jpg', 'png', 'jpeg']
      var reader = new FileReader()
      let _this = this
      reader.onloadend = (e) => {
        let arr = new Uint8Array(e.target.result).subarray(0, 4)
        let header = ''
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16)
        }

        let mimeType = Utils.mimeType(header)
        if (mimeType === 'unknown') {
          return _this.$alertify.alertWithTitle(
            _this.$t('Confirm'),
            _this.$t('Only these file types are accepted') +
              ' : ' +
              validExtensions.join(', ')
          )
        }
        var image = new Image()

        var base64Image = new Buffer(e.target.result, 'binary').toString(
          'base64'
        )
        image.src = 'data:image/png;base64,' + base64Image
        image.onload = () => {
          // console.log(image.width);
          if (image.width < 600) {
            alert('Ảnh phải có chiều dài tối thiểu là 600px')
            return
          }
          if (image.height < 600) {
            alert('Ảnh phải có chiều rộng tối thiểu là 600px')
            return
          }

          this.uploadFile(file)
        }
        // _this.src_image = "data:image/png;base64," + base64Image;
      }
      reader.readAsArrayBuffer(file)
    },

    uploadFile (file) {
      let formData = new FormData()
      formData.append('file', file)

      let headers = {
        'Content-Type': 'multipart/form-data'
      }
      Utils.requestV2(this, true)
        .post('/upload', formData, { headers: headers })
        .then(response => {
          console.log('response', response)
          this.item.photos.push(response.data)
        })
        .catch(function (e) {
          console.log(e)
          console.log('FAILURE!!')
        }).finally(() => {
          this.working = false
        })
    },
    removePhoto (index) {
      console.log('index', index)
      this.item.photos.splice(index, 1)
    },
    open () {
      this.$refs.theModal.open()

      this.item = null
      let item
      if (this.pass_data) {
        item = JSON.parse(JSON.stringify(this.pass_data))
        item.manufacture_at = this.$moment(item.manufacture_at).format(
          this.dateFormat
        )
        // console.log('item',item)
      } else {
        item = this.defaultValue()

        
      }
      this.item = item
    },

    submitForm () {
      let data = JSON.parse(JSON.stringify(this.item))
      console.log('data.manufacture_at', data.manufacture_at)
      data.manufacture_at = this.$moment(
        data.manufacture_at,
        this.dateFormat
      ).format('YYYY-MM-DD')
      console.log('data', data)


      if (data.photos.length === 0) {
        return this.$alertify.alertWithTitle(
          this.$t('Confirm'),
          'Bạn cần upload ít nhất 1 hình ảnh'
        )
      }

      let request

      if (this.item.id) {
        // PUT request does not support validation
        request = Utils.requestV2(this, true).put(`/agricultural-ads/`, data)
      } else {
        request = Utils.requestV2(this, true).post(`/agricultural-ads/`, data)
      }
      this.working = true
      request
        .then((response) => {
          // let data = response.data

          this.$refs.theModal.close()
          this.$emit('modalData', {})
        })
        .catch((error) => {
          this.working = false
          Utils.showErrorMessage(this, error.response)
        })
    },
    updateLocation (data) {
      for (let key in data) {
        this.item[key] = data[key]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AgriculturalAd/FormAgriculturalAd.vue